export default __webpack_public_path__ + "static/media/hainan.1c636cba.png";